var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuilding = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14 13.333h1.333v1.334H.667v-1.334H2V2a.667.667 0 0 1 .667-.667h10.666A.667.667 0 0 1 14 2zm-1.333 0V2.667H3.333v10.666zm-7.334-6h2v1.334h-2zm0-2.666h2V6h-2zm0 5.333h2v1.333h-2zm3.334 0h2v1.333h-2zm0-2.667h2v1.334h-2zm0-2.666h2V6h-2z"
})));
export default SvgBuilding;